'use strict';

const { h, Component } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');
const { hydrate } = require('@grpn/hydration');

const SearchClient = require('../../support/search-client');
const truncateLongWords = require('../../support/truncate-long-words');

class Search extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = { results: [] };
    this.refs = { input: null };

    this.keyUpHandlerSearch = this.keyUpHandlerSearch.bind(this);
    this.clickHandlerResult = this.clickHandlerResult.bind(this);
  }

  componentDidMount() {
    const { searchCredentials } = this.props;

    const {
      countryCode,
      domainId,
      algoliaApiId,
      algoliaApiKey,
      algoliaApiIndex,
    } = searchCredentials;

    this.client = new SearchClient({
      countryCode,
      domainId,
      config: {
        id: algoliaApiId,
        key: algoliaApiKey,
        index: algoliaApiIndex,
      },
    });
  }

  render() {
    const { results } = this.state;
    const searchId = 'discountcodes_search';

    return h('.search', [
      h('span.search-icon.icon-magnifying-glass', {
        'data-bhw': 'CouponSearchButton',
      }),
      h('.search-inner', [
        h(
          'label.sr-only',
          {
            for: searchId,
          },
          h(Translate, 'js.modules.header.Search')
        ),
        h(WithI18n, {}, i18n =>
          h('input.search-input', {
            id: searchId,
            placeholder: i18n.t('js.modules.header.Search'),
            onKeyUp: this.keyUpHandlerSearch,
            ref: el => (this.refs.input = el),
            'data-bhw': 'CouponSearchField',
          })
        ),
        h('ul.search-list', results.map(item => this.getSearchResult(item))),
      ]),
    ]);
  }

  getSearchResult({ tradingName, totalOffersByDomainIds, mediaPath, urlSlug }) {
    const image = mediaPath.replace('{{options}}', 'w_72,h_72,c_fill,');

    const totalOffers = this.getTotalOffers({ totalOffersByDomainIds });
    const { routes } = this.props;

    return h('li.search-result', [
      h(
        'a.search-result-link',
        {
          href: routes.merchant.show.replace('{merchantSlug}', urlSlug),
          onClick: this.clickHandlerResult,
        },
        [
          h('.search-result-logo', h('img.image', { src: image })),
          h(
            '.search-result-content',
            h('.search-result-content-inner', [
              h('span.search-result-title', truncateLongWords(tradingName)),
              h(
                Translate,
                {
                  tag: 'span',
                  attrs: { class: 'search-result-count' },
                  0: totalOffers,
                },
                'js.modules.search.TotalOfferCount'
              ),
            ])
          ),
        ]
      ),
    ]);
  }

  getTotalOffers({ totalOffersByDomainIds }) {
    const {
      searchCredentials: { domainId },
    } = this.props;

    const totalDomain = totalOffersByDomainIds[domainId] || 0;

    return Math.min(Math.max(totalDomain, 0), 100);
  }

  keyUpHandlerSearch(ev) {
    const { client } = this;

    const value = ev.target.value;

    if (value.length < 2) {
      this.setState({
        results: [],
      });
      return;
    }

    client.query(value).then(({ hits }) => this.setState({ results: hits }));
  }

  clickHandlerResult() {
    const { input } = this.refs;

    input.value = '';

    this.setState({
      results: [],
    });
  }
}

module.exports = hydrate('Search', Search);
module.exports.Search = Search;
